var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelFoursquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17.803 3c1.47 0 1.866.803 1.546 2.293-.419 1.953-1.673 8.107-1.784 8.54-.135.518-.341 1.397-1.627 1.397H12.88c-.123 0-.123 0-.245.118-.078.073-4.337 4.81-4.774 5.297l-.036.04c-.368.407-.982.334-1.205.248S6 20.584 6 19.877V4.624C6 3.996 6.406 3 7.788 3Zm-1.088 1.984H8.678a.613.613 0 0 0-.609.583V17.47c0 .036.03.045.06.012 0 0 2.96-3.408 3.29-3.8.329-.392.477-.454.97-.454h2.701a.64.64 0 0 0 .615-.471c.037-.174.352-1.748.42-2.065.066-.318-.238-.643-.548-.643h-3.31c-.44 0-.755-.299-.755-.72v-.457c0-.42.314-.708.753-.708h3.901c.277 0 .575-.238.625-.465l.42-2.1a.505.505 0 0 0-.496-.615"
})));
export default SvgGemChannelFoursquare;